import { type PartnerLinks } from "@/features/partners/types/partnerLink"

export const EFFY_PORTAIL_LINKS = [] as const satisfies PartnerLinks
